import React, { useEffect } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Table, Form } from 'react-bootstrap';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

export default function Transaction() {
    // datatable
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableTransaction')) {
            $('#mainDatatableTransaction').DataTable({
                dom: "Bflrtip",
                buttons: [
                    {
                        extend: 'excel',
                        className: 'btn btn-outline-secondary',
                        text: '<svg viewBox="0 0 24 24" role="presentation" class="btn-icon me-1"><path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z" style="fill: currentcolor;"></path></svg> Export to Excel'
                    }
                ],
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
        }

        if (document.getElementsByClassName("dt-buttons").length) {
            document.getElementById("mainDatatableTransaction_wrapper").classList.add("dtl-right");
        } else {
            document.getElementById("mainDatatableTransaction_wrapper").classList.remove("dtl-right");
        }
    }, []);
    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-sm-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-sm-0'>Advance Payment</Card.Title>
                                            <div>
                                                <Form className='d-sm-flex align-items-center '>
                                                    <Form.Select  size="sm" className='me-sm-3 mb-sm-0 mb-3'>
                                                        <option>All Time</option>
                                                        <option value="1">All Time</option>
                                                        <option value="2">Two</option>
                                                    </Form.Select>
                                                    <Form.Select  size="sm" className='me-sm-3 mb-sm-0 mb-3'>
                                                        <option>All</option>
                                                        <option value="1">Select One</option>
                                                        <option value="2">Two</option>
                                                    </Form.Select>
                                                    <Form.Select  size="sm">
                                                        <option>All</option>
                                                        <option value="1">Select One</option>
                                                        <option value="2">Two</option>
                                                    </Form.Select>
                                                </Form>
                                            </div>
                                        </div>
                                        <Table responsive bordered className='table-nowrap' id='mainDatatableTransaction'>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Sr.No</th>
                                                    <th>Account</th>
                                                    <th>Payment Date</th>
                                                    <th>Amount</th>
                                                    <th>Module</th>
                                                    <th>Reff.No</th>
                                                    <th>Credit/Debit</th>
                                                    <th>Payee Type</th>
                                                    <th>Payee</th>
                                                    <th>Payment Mode</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Saving</td>
                                                    <td>28/12/2022</td>
                                                    <td>5,000</td>
                                                    <td>Null</td>
                                                    <td>201365</td>
                                                    <td>Debit</td>
                                                    <td>Online</td>
                                                    <td>5,000</td>
                                                    <td>Bank</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
